angular
	.module 'App.Repository'
	.factory 'DistributorRepository', ['BaseRepository', (BaseRepository) ->
		class DistributorRepository extends BaseRepository
			@resource = '/distributors'
			@isRestricted = true

		return new DistributorRepository
	]
